import React, { useRef, useContext, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  TextField,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import { authenticateUserDiscount } from "../../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import Loading from "./../../../../components/basics/Loading";
import MaskService from "./../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";

const ModalDesconto = ({
  open,
  setOpen,
  // O callback sempre vai ter um parâmetro que é o ID de usuário,
  // no caso, o que tentaram logar, e conseguiram.
  callback = () => {},
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [authenticateError, setAuthenticateError] = useState("");
  const [loadingState, setLoadingState] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSendData = async () => {
    let emailValue = emailRef.current?.value;
    let passwordValue = passwordRef.current?.value;

    try {
      setLoadingState(true);
      const request = await authenticateUserDiscount({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          params: Buffer.from(
            JSON.stringify({
              email: emailValue,
              password: passwordValue,
            })
          ).toString("base64"),
        },
      });

      if (request.success) {
        if (!request.data?.idUsuario)
          return notify("ID de usuário não encontrado.");

        callback(
          MaskService.toMask(
            "decimal",
            parseFloat(request.data?.desconto || "0.00").toFixed(2)
          )
        );
        handleClose();
        return notify("Desconto máximo alterado com sucesso!", true, "success");
      } else {
        setAuthenticateError(request.message);
        return notify(request.message);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingState(false);
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <Loading open={loadingState} />
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        children="Autenticação do usuário"
      />
      <DialogContent>
        <Grid
          container
          spacing={2}
          style={{ flexDirection: "column", marginBottom: "25px" }}
        ></Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              label="E-mail"
              fullWidth
              type="email"
              inputProps={{
                ref: emailRef,
              }}
              error={!!authenticateError}
              helperText={authenticateError || ""}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              label="Senha"
              fullWidth
              type="password"
              inputProps={{
                ref: passwordRef,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          autoFocus
          onClick={handleClose}
          bgcolor="grey"
          hovercolor="blue"
          label="Cancelar"
        />
        <Btn
          autoFocus
          onClick={handleSendData}
          bgcolor="primary"
          hovercolor="orange"
          label="Liberar desconto"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalDesconto;
